import { createClient, SupabaseClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://chqqfmkywedgovpjbato.supabase.co'
const SUPABASE_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNocXFmbWt5d2VkZ292cGpiYXRvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njg5MDI3MTEsImV4cCI6MjA4NDQ3ODcxMX0.kLIG9RZEHVpheKI3y9OpMCKEaIcjHr4yO3s8qzV6ak4'

export const supabase: SupabaseClient = createClient(
  SUPABASE_URL,
  SUPABASE_ANON_KEY,
)
export const isSupabaseConfigured = true
